import { i18n } from '@/i18n/i18n'
import {
  type ApplicationConfig,
  ApplicationConfigService,
} from '@/shared/service/applicationConfig.service'
import { ErrorService } from '@/shared/service/errorService'
import { FilesService } from '@/shared/service/files.service'
import { SnackbarService } from '@/shared/snackbar/snackbar.service'

import { commitAppConfig } from '../../shared/store/app-config.store'
import { InternalType } from '../../shared/types/files.type'
import { createStore, type GettersObj } from '../../utils/createStore'

export type GettersSplashScreen = GettersObj<typeof mapGettersSplashScreen>

export class SplashScreenState {
  applicationCfg: ApplicationConfig | null = null
  cropSplashImage: string | null = null
  guardCropImg: string | null = null
  loading = true
}

export const {
  splashScreen,
  commit: commitSplashScreen,
  dispatch: dispatchSplashScreen,
  mapGetters: mapGettersSplashScreen,
  mapState: mapStateSplashScreen,
  useGetter: useGetterSplashScreen,
  useState: useStateSplashScreen,
} = createStore({
  namespaced: true,
  moduleName: 'splashScreen',
  initState: new SplashScreenState(),
  mutations: {
    SET_CROP_SPLASH_IMAGE(state, payload: string) {
      state.cropSplashImage = payload
      if (state.guardCropImg == null) {
        state.guardCropImg = payload
      }
    },
  },
  actions: {
    async init({ state }) {
      try {
        state.loading = true

        const applicationCfg = await ApplicationConfigService.get()
        state.applicationCfg = applicationCfg

        commitAppConfig('SET_APP_CONFIG', applicationCfg)
      } catch (e) {
        ErrorService.handleError(e)
      } finally {
        state.loading = false
      }
    },

    async save({ state }) {
      try {
        state.loading = true

        if (state.cropSplashImage == null || state.applicationCfg == null) {
          return
        }

        const { filename } = await FilesService.uploadImage({
          image: state.cropSplashImage,
          internalType: InternalType.SPLASHSCREEN,
        })
        const applicationCfg =
          await ApplicationConfigService.updateSplashImage(filename)

        state.guardCropImg = state.cropSplashImage
        state.applicationCfg = applicationCfg
        commitAppConfig('SET_APP_CONFIG', applicationCfg)

        SnackbarService.info(i18n.tc('APPLICATION_CFG.SAVE'))
      } catch (e) {
        ErrorService.handleError(e)
      } finally {
        state.loading = false
      }
    },
  },
  getters: {},
})
